import script from "./clientFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./clientFile.vue?vue&type=script&setup=true&lang=ts"

import "./clientFile.vue?vue&type=style&index=0&id=4f3afa16&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f3afa16"]])

export default __exports__